/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
function plural(val) {
  const n = val;
  return 5;
}
export default ["my", [["နံနက်", "ညနေ"], u, u], u, [["တ", "တ", "အ", "ဗ", "က", "သ", "စ"], ["တနင်္ဂနွေ", "တနင်္လာ", "အင်္ဂါ", "ဗုဒ္ဓဟူး", "ကြာသပတေး", "သောကြာ", "စနေ"], u, u], u, [["ဇ", "ဖ", "မ", "ဧ", "မ", "ဇ", "ဇ", "ဩ", "စ", "အ", "န", "ဒ"], ["ဇန်", "ဖေ", "မတ်", "ဧ", "မေ", "ဇွန်", "ဇူ", "ဩ", "စက်", "အောက်", "နို", "ဒီ"], ["ဇန်နဝါရီ", "ဖေဖော်ဝါရီ", "မတ်", "ဧပြီ", "မေ", "ဇွန်", "ဇူလိုင်", "ဩဂုတ်", "စက်တင်ဘာ", "အောက်တိုဘာ", "နိုဝင်ဘာ", "ဒီဇင်ဘာ"]], u, [["ဘီစီ", "အဒေီ"], u, ["ခရစ်တော် မပေါ်မီနှစ်", "ခရစ်နှစ်"]], 0, [6, 0], ["dd-MM-yy", "y- MMM d", "y- MMMM d", "y- MMMM d- EEEE"], ["H:mm", "H:mm:ss", "z HH:mm:ss", "zzzz HH:mm:ss"], ["{1} {0}", u, u, u], [".", ",", ";", "%", "+", "-", "E", "×", "‰", "∞", "ဂဏန်းမဟုတ်သော", ":"], ["#,##0.###", "#,##0%", "#,##0.00 ¤", "#E0"], "MMK", "K", "မြန်မာ ကျပ်", {
  "ANG": ["NAf"],
  "AWG": ["Afl"],
  "BBD": [u, "Bds$"],
  "BSD": [u, "B$"],
  "BYN": [u, "р."],
  "HTG": ["G"],
  "JPY": ["JP¥", "¥"],
  "MMK": ["K"],
  "PAB": ["B/."],
  "PHP": [u, "₱"],
  "THB": ["฿"],
  "TTD": ["TT$", "$"],
  "USD": ["US$", "$"]
}, "ltr", plural];
